import { apiCallCenter } from '@/plugins/axios'
import { hostname } from '@/utils/hostname'


export default {
  postRelatorioDetalhadoDisponibilidade(idOperador, data) {
    return apiCallCenter().post(`/relatorios/disponibilidade/operadores/detalhado/${idOperador}?_method=GET`, data)
  },
  exportExcel(params) {
    let query = `dataHoraInicio=${encodeURI(params.dataHoraInicio)}&dataHoraFim=${encodeURI(params.dataHoraFim)}`

    if(params.operadores.length == 0){
      query = `${query}&operadores[]=${params.operadores}`
    }else{
      params.operadores.forEach(operadores => {
        query = `${query}&operadores[]=${operadores}`
      })
    }

    const token = window.localStorage.getItem('pcm_access_token')
    query = `${query}&token=${token}`
    return `https://${hostname()}/backend/callcenter/relatorios/disponibilidade/detalhado/export?${query}`
  },
}
